export default {
	breadArray(state){
		return state.breadArray;
	},
	userInfo(state){
			return state.userInfo;
	}
}